__turbopack_context__.v({
  "left_container": "SingleTestimonial-module-scss-module__QdaLaa__left_container",
  "module_image": "SingleTestimonial-module-scss-module__QdaLaa__module_image",
  "single_testimonial_container": "SingleTestimonial-module-scss-module__QdaLaa__single_testimonial_container",
  "single_testimonial_quote_content": "SingleTestimonial-module-scss-module__QdaLaa__single_testimonial_quote_content",
  "single_testimonial_with_image": "SingleTestimonial-module-scss-module__QdaLaa__single_testimonial_with_image",
});
